import { Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { UserIcon } from '../Icon';
import './AuthenticatedWelcomeRow.css';

interface AuthenticatedWelcomeRowProps {
  /**
   * Test ID for automated testing
   */
  'data-testid'?: string;
}

function AuthenticatedWelcomeRow({ 'data-testid': dataTestId }: AuthenticatedWelcomeRowProps) {
  const { user } = useAuth();
  // Read snake_case (per docs/api/auth-api-spec.yaml) first, fall back to the
  // legacy camelCase fields the current /me handler still returns. This makes
  // the row forward-compatible: when the backend aligns to the spec, drop the
  // camelCase fallback and the legacy fields on `CurrentUser['profile']`.
  const firstName = user?.profile?.first_name ?? user?.profile?.firstName ?? '';
  const lastName = user?.profile?.last_name ?? user?.profile?.lastName ?? '';
  const displayName = `${firstName} ${lastName}`.trim() || 'User';
  const baseTestId = dataTestId ?? 'authenticated-welcome-row';

  return (
    <section
      aria-labelledby={`${baseTestId}-label`}
      className='authenticated-welcome-row'
      data-testid={baseTestId}>
      <div
        className='authenticated-welcome-row__text'
        data-testid={`${baseTestId}-text`}>
        <span
          className='authenticated-welcome-row__label'
          data-testid={`${baseTestId}-label`}
          id={`${baseTestId}-label`}>
          Welcome
        </span>
        <Link
          className='authenticated-welcome-row__name'
          data-testid={`${baseTestId}-name`}
          to='/profile'>
          {displayName}
        </Link>
        <span data-testid={`${baseTestId}-icon`}>
          <UserIcon
            className='authenticated-welcome-row__icon'
            size={24}
          />
        </span>
      </div>
    </section>
  );
}

export default AuthenticatedWelcomeRow;
